import "./App.css";
import RootRoutes from "./routes/RootRoutes";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RootRoutes />
    </QueryClientProvider>
  );
}

export default App;
